import { Manifesto } from "../components/Manifesto";
import { StatsDashboard } from "../components/StatsDashboard";
import { ContactCTA } from "../components/ContactCTA";
import { Reveal } from "../components/Shared";
import { MapPin, Mail, Phone, Globe } from "lucide-react";
import { CONTACT } from "../data/apps";

const INFOS = [
  { icon: Globe, label: "Site officiel", value: CONTACT.site },
  { icon: Mail, label: "E-mail", value: CONTACT.email },
  { icon: Phone, label: "Téléphone", value: CONTACT.phone },
  { icon: MapPin, label: "Siège", value: CONTACT.address },
];

export default function About() {
  return (
    <main data-testid="about-page" className="pt-[70px]">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 lg:pt-24 pb-6">
        <Reveal>
          <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">À propos</div>
          <h1 className="mt-4 font-display font-semibold tracking-tight text-navy text-4xl sm:text-5xl lg:text-6xl max-w-4xl text-balance">
            TIRERA GROUP, l'écosystème numérique né à Bamako.
          </h1>
          <p className="mt-6 max-w-2xl text-muted-foreground leading-relaxed text-lg">
            TIRERA GROUP SARL est une entreprise technologique malienne qui développe des applications
            au service du quotidien. Notre mission : construire un écosystème complet, fiable et accessible
            à tous, réunissant mobilité, immobilier, construction, commerce et services islamiques sous une même identité.
          </p>
        </Reveal>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {INFOS.map((info, i) => {
            const Icon = info.icon;
            return (
              <Reveal key={info.label} i={i}>
                <div className="rounded-2xl border border-border p-6 h-full">
                  <Icon size={20} className="text-navy/40" />
                  <div className="mt-4 text-xs uppercase tracking-wider text-muted-foreground">{info.label}</div>
                  <div className="mt-1 font-display font-semibold text-navy break-words">{info.value}</div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <Manifesto />
      <StatsDashboard />
      <ContactCTA />
    </main>
  );
}
